
// const brands = {
//   BMW: "BMW+I3",
//   MINI: "MINI",
// };
if (document.getElementById("check-plate-form")) {
  document.getElementById("check-plate-form").addEventListener("submit", async (e) => {
    const formData = new FormData(e.target.closest('form'));
    e.preventDefault();
    // Create an instance of the FacetFiltersForm

const plateNumber = e.target.plateNumber.value
  .replace(/-/g, '')
  .replace(/\s/g, '')
  .toUpperCase();

let url = `https://opendata.rdw.nl/resource/m9d7-ebf2.json?kenteken=`;
url += plateNumber + `&$select=merk,variant`;
    document.querySelector(".inset").style.border = "2px solid black";
    let getModel;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "X-App-Token": "QW2675LYlkfwFkwysh6kAW2gs",
        },
      });
      if (!response.ok) {
        throw new Error("Failed to get the model based on plate numner (!)");
      } else {
        document.cookie = `plate=${plateNumber}; path=/;`;
        const data = await response.json();
        const variant = data && data[0] && data[0].variant;
        
        const result = brands.find(({
          variantCode
        }) => variantCode === variant);
        if (result) {

        }
        getModel = result.model;

        document.querySelector('#modelHeader').innerHTML = result.model
        if (!result.model) {
          throw new Error("Failed to get the model based on plate numner (!)");
        }
        // filter.p.m.custom.brand_and_model=brands[merk]
        // filter.p.vendor=' + brands[merk];
        let filterNavigation = `?filter.p.m.custom.brand_and_model=${result.model}`;
        if (result.model) {
          if (window.location.href.includes('collections')) {
            window.history.pushState({}, '', `${filterNavigation}`);
            const zomer = document.getElementById("Zomer")
            if (zomer) {
              zomer.href = `/collections/wielset-zomer${filterNavigation}`;

            }
            document.getElementById("brand_all_product").href = `/collections/alle-producten?filter.p.m.custom.brand_and_model=${result.model}`;
            document.cookie = `model=${result.model}; path=/;`;
            FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
            const searchParams = e.state ? e.state.searchParams : FacetFiltersForm.searchParamsInitial;
            FacetFiltersForm.renderPage(searchParams, e);
            document.querySelector(".close").style.display = "block"
          } else {
            document.querySelector('#modelHeader').innerHTML = result.model
            document.cookie = `model=${result.model}; path=/;`
            document.cookie = `plate=${plateNumber}; path=/;`
            window.location.href = `/collections/alle-producten${filterNavigation}`;
            const zomer = document.getElementById("Zomer")
            if (zomer) {
              document.getElementById("Zomer").href = `/collections/wielset-zomer${filterNavigation}`
            }
          }
      }

      }
    } catch (error) {

      if(!getModel){
        console.log("Error: ", error);
        document.querySelector(".errorHandle").innerHTML = "Voor het ingevoerde kenteken hebben wij op dit moment geen (auto-specifiek) productaanbod in onze webshop";
        document.querySelector(".inset").style.border = "2px solid red";
      }
     

    }
  });
}
/**
 * It returns the value of the cookie with the given name
 * @param name - The name of the cookie you want to get.
 * @returns The value of the cookie with the name passed in as an argument.
 */
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}

let storedModel = getCookie("model");
console.log('MODELS',getCookie("model"));

/* Getting all the nav items and then looping through them. */
const navItems = document.querySelectorAll(".nav-menu-item");
navItems.forEach((navItem) => {
  const model = navItem.dataset.model;
  const navigateTo = navItem.href;

/* Checking if the storedModel is true or false. If it is true, it will add the storedModel to the url.
If it is false, it will not add the storedModel to the url. */
  document.getElementById(model).href = storedModel ? 
  navigateTo + `?filter.p.m.custom.brand_and_model=${storedModel}` : 
  navigateTo;

  document.getElementById("brand_all_product").href = `/collections/alle-producten?filter.p.m.custom.brand_and_model=${storedModel}` 
  
});

/* Checking if the storedModel is true or false. If it is true, it will display the model in the
header. If it is false, it will not display the model in the header. */
if (storedModel) {
  document.querySelector('#modelHeader').innerHTML = storedModel;
  
/* Checking if the url includes the word collection. If it does, it will display the model in the
header and hide the platenumber section. */
if (window.location.href.includes('collection')) {
  document.getElementsByClassName('show_title').innerHTML = storedModel;
  document.getElementById('platenumberSection').style.display = 'none';
}


}

// remove cookie when close button is clicked on every single page

if (document.querySelector(".thb-secondary-area .close")) {
  document.querySelector(".thb-secondary-area .close").addEventListener("click", () => {
    if (window.location.href.includes('collection')) {
      document.cookie = "model=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/collections;";
      document.cookie = "model=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      document.cookie = "model=; max-age=-1; path=/collections;";
    } else {
      document.cookie = "model=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      document.cookie = "model=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/collections;";
      document.cookie = "model=; max-age=-1; path=/;";
    }

    window.location.href = "/";
  });

  /* Checking if the storedModel is true or false. If it is true, it will display the close button. If it
  is false, it will not display the close button. */
  storedModel ?
    document.querySelector(".close").style.display = "block" :
    document.querySelector(".close").style.display = "none";
}
